export default __webpack_public_path__ + "static/media/apple_svg_logo.ba789c16.svg";